import { CellType } from "./interfaces";
export var defaultProps = {
  shouldScrollHorizontally: true,
  descendingTitleText: 'Sort in descending order',
  ascendingTitleText: 'Sort in ascending order',
  actionHeader: 'Action',
  getRowAttributes: function getRowAttributes() {
    return {};
  }
};
export var defaultRowAttributes = {
  actionLabel: 'More details',
  expandableTriggerText: 'Details',
  shouldVisuallyHideTriggerText: true,
  disabledActionLabel: 'Not available'
};
export var defaultColumnAttributes = {
  headerCellType: CellType.Header,
  dataCellType: CellType.Data
};